<template>
	<table class="table table-bordered">
		<thead>
			<tr>
				<th>
					{{ $t('donation-form.summary_details_col_header') }}
				</th>
				<th class="text-center" style="width:130px;">
					{{ $t('donation-form.summary_quantity_col_header') }}
				</th>
				<th class="text-right" style="width:100px;">
					{{ $t('donation-form.summary_amount_col_header') }}
				</th>
			</tr>
		</thead>
		<tbody>
			<template v-for="(campaign, key) in summary" :key="campaign">
				<template v-if="key != '_fbp'">
					<tr class="bg-light text-bold-500">
						<td colspan="3">
							{{ key }}
						</td>
					</tr>

					<template v-for="cpackage in campaign" :key="cpackage.id">
						<tr>
							<td class="align-middle">
								{{ cpackage.name }}

								<div>
					                <span class="text-bold-500" v-if=" ! cpackage.custom_amount_enabled">
					                  {{ vueNumberFormat(cpackage.amount) }}
					                </span>
								</div>
							</td>
							<td class="align-middle text-center">
								{{ cpackage.count }}
							</td>
							<td class="align-middle text-right">
								{{ vueNumberFormat(cpackage.amount * cpackage.count) }}
							</td>
						</tr>
					</template>
				</template>
			</template>
		</tbody>
		<tfoot>
			<tr>
				<th colspan="2" class="align-middle text-right">
					{{ $t('donation-form.total') }}
				</th>
				<th class="align-middle text-right">
					{{ vueNumberFormat(total) }}
				</th>
			</tr>

			<!-- Payment Gateway Fees -->
			<tr v-if="formData.payment_gateway_fees_enabled">
				<th colspan="3" class="align-middle text-right">
					<span class="text-normal alert-warning p-1">
						{{ $t('donation-form.payment_gateway_fees').replace('#amount#', vueNumberFormat(props.formData.payment_gateway_fees)) }}
					</span>
				</th>
			</tr>
		</tfoot>
	</table>
</template>

<script setup>
import useHelpers from "@/Composables/UseHelpers";

const {$t} = useHelpers();

const props = defineProps({
	formData: Object,
	donations: Object,
	summary: Object,
	campaigns: Object,
	total: {
		type: Number,
		default: 0
	}
});
</script>
